var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"demo-header"},[_c('div',{attrs:{"id":"title-container"}},[_c('a',{attrs:{"id":"title","href":_vm.link}},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default"),_c('bryntum-fullscreen-button')],2)}
var staticRenderFns = []

export { render, staticRenderFns }